export const LIST_ADMIN_CONFIGS = `query ($category: String) {
  list_admin_configs(category: $category) {
    message
    data {
      key
      label
      value
      input
      help
      placeholder
      required
      category_label
      category_help
      group
      group_help
      item_label
      item_pattern
      pattern
      uppercase
      is_default
      updated_by
      updatedAt
    }
  }
}`;

// Saves the whole form in one call. type and category come from the backend registry, so
// only the key and the value travel.
export const SET_ADMIN_CONFIGS = `mutation ($configs: [set_admin_configs_configs]!) {
  set_admin_configs(configs: $configs) {
    message
  }
}`;
